import { ReactNode } from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";

const CustomLink = ({ children, to, ...props }: { children: ReactNode, to: string }) => {
    let resolved = useResolvedPath(to);
    const containers = ["rapporter", "bilder-og-video", "tilgangstyring", "avtaler"];
    let match = useMatch({ path: resolved.pathname, end: containers.includes(to) ? false : true });

    return (
        <li className="nav-item unbreakable">
            <Link
                className={`nav-link px-0 mx-2 mx-lg-4 ${match && 'active'}`}
                to={to}
                {...props}
            >
                {children}
            </Link>
        </li>
    );
}

export default CustomLink;